import { defineMessage } from 'services/localization';

export const messages = {
    closeButtonText: defineMessage('go_to_requests'),
    headerText: defineMessage('all_done'),
    descriptionCommon: defineMessage('the_workflow_is_activat_in_the_list_of_requests'),
    descriptionStandalone: defineMessage('the_workflow_is_activat_in_the_list_of_requests_1'),
};
